import request from 'services/requests';

export const getProfileGeneralDataAsync = async () => {
  try {
    const res = await request({
      endpoint: `user/profile/general-data`,
      method: 'GET',
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateProfileGeneralDataAsync = async (payload) => {
  try {
    const res = await request({
      endpoint: `user/profile/general-data`,
      method: 'PUT',
      data: payload,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const changePasswordAsync = async (payload) => {
  try {
    const res = await request({
      endpoint: `user/change-password`,
      method: 'PATCH',
      data: payload,
    });
    return res;
  } catch (error) {
    throw error;
  }
};